import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/collections/pendingRecharges/store/pendingRechargeSlice/initialState.ts'
import {
  PendingRecharge,
  PendingRechargeObject
} from '@/modules/collections/pendingRecharges/types/PendingRecharge.ts'
import { NestedFilterObject } from '@/core/hooks/useFiltersInBody.ts'

const pendingRechargeSlice = createSlice({
  name: 'pendingRecharge',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setLoadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoadingAction = action.payload
    },
    setPendingRecharges: (state, action: PayloadAction<PendingRecharge[]>) => {
      state.pendingRecharges = action.payload
    },
    setEditId: (state, action: PayloadAction<string | null>) => {
      state.editId = action.payload
    },
    setFilters: (state, action: PayloadAction<NestedFilterObject>) => {
      state.filters = action.payload
    },
    setEditObj: (
      state,
      action: PayloadAction<PendingRechargeObject | null>
    ) => {
      state.pendingRecharge = action.payload
    },
    reset: () => initialState
  }
})

export const pendingRechargeActions = pendingRechargeSlice.actions
export const { reducer: pendingRechargeReducer } = pendingRechargeSlice
